import { Component, OnInit, ViewChild } from "@angular/core";
import { FilterConstants } from "src/app/constants/filterConstants";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { TokenService } from "src/app/core/services/token.service";

import { TableConstants } from "src/app/constants/tableConstants";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { MaintenanceHistoricoBastidorService } from "src/app/maintenance-historico-bastidor/maintenance-historico-bastidor.service";
import { FiltersComponent } from "src/app/shared/filters/filters.component";
import { Options } from "src/app/shared/filters/models/filters.model";
import { ScreenConstants } from "src/app/constants/screenId.constants";
import { CommonService } from "src/app/core/services/common.service";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";

@Component({
  selector: "maintenance-historico-bastidor-list",
  templateUrl: "./maintenance-historico-bastidor-list.component.html",
})
export class MaintenanceHistoricoBastidorListComponent implements OnInit {
  @ViewChild("insideTable") filtersInsideTable: FiltersComponent;
  public filtersTable;
  public filtersSearch = "";

  public listItems: any[];
  filterList = FilterConstants.maintenanceHistoricoBastidor;
  tableList = TableConstants.maintenanceHistoricoBastidor;
  routing = RoutingConstants.maintenanceHistoricoBastidor;
  options: Options = TableConstants.NotShowDeleteAndArrowUpDown;
  numPages: number = 0;
  numElements: number = 0;
  totalElements: number = 0;
  filtersTableJSON;
  listBastidores: any[];

  showTableFilter: boolean = false;
  showFilterButtons: boolean = false;

  constructor(
    private maintenanceHistoricoBastidorService: MaintenanceHistoricoBastidorService,
    private filtersTableStateService: FiltersTableStateService,
    private toastrAlertService: ToastrAlertService,
    private tokenService: TokenService,
    private sweetAlertService: SweetAlertService,
    private commonService: CommonService
  ) {
    this.options.style = { "min-width": "1245px" };
    this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
      this.routing.id,
      ScreenConstants.admSistemas.historicoBastidor
    );
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );
    this.filtersSearch = this.filtersTableStateService.composeFiltersInTable(
      this.filterList
    );
  }

  ngOnInit(): void {
    this.loadInitialList();
  }

  loadInitialList(): void {
    let filters = this.commonService.concatFilters(
      this.filtersTable,
      this.filtersSearch
    );
    this.sweetAlertService.sweetAlertLoading();
    this.maintenanceHistoricoBastidorService.list(filters).subscribe(
      (data) => {
        this.listItems = data["content"];
        this.numPages = data["totalPages"] == 0 ? 1 : data["totalPages"];
        this.numElements = data["numberOfElements"];
        this.totalElements = data["totalElements"];
        this.sweetAlertService.sweetAlertClose();
      },
      (err) => {
        this.toastrAlertService.toastrFail(
          err.error.mensaje
            ? err.error.mensaje
            : "Error al cargar lista de usuarios"
        );
      }
    );
    if (this.listBastidores?.length === 0) {
      this.toastrAlertService.toastrFail(
        "No se han encontrado usuarios con esos datos"
      );
    }
  }

  filterTable(value: any) {
    this.filtersTableJSON = value.filterTableJSON;
    this.filtersTable = value.filterTableString;
    this.loadInitialList();
  }

  removeElements(ids: string[]) {
    this.maintenanceHistoricoBastidorService.deleteBastidor(ids).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess("Bastidor/s eliminado/s");
        this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
          this.routing.id,
          ScreenConstants.admSistemas.historicoBastidor
        );
        this.filtersTable = this.filtersTableStateService.getString(
          this.filtersTableJSON
        );
        this.loadInitialList();
      },
      (err) => {
        this.toastrAlertService.toastrFail(
          err.error.mensaje ? err.error.mensaje : "Error al eliminar usuario/s"
        );
      }
    );
  }

  buttonsHeader(item: string) {
    switch (item) {
      case "erase":
        this.filtersInsideTable.filtersSelectorSearch = [];
        this.filtersInsideTable.filtersValuesSearch = [];
        this.filtersInsideTable.cleanSelectorAndDates();
        break;
      case "search":
        this.filtersSearch = this.filtersInsideTable.composeParams();
        this.filtersTableStateService.setPageState(0);
        this.filtersTableJSON =
          this.filtersTableStateService.getFiltersTableState();
        this.filtersTable = this.filtersTableStateService.getString(
          this.filtersTableJSON
        );
        this.loadInitialList();
        break;
      case "toggleFilters":
        if (this.showTableFilter) {
          this.showTableFilter = false;
          this.showFilterButtons = false;
        } else {
          this.showTableFilter = true;
          this.showFilterButtons = true;
        }
        break;
    }
  }
  goPredefinedMailBox() {
    this.tokenService.redirectPredefinedMailBox();
  }

  public showFilters(type: string) {
    if (type === "normal") {
      this.showTableFilter = true;
    }
    this.showFilterButtons = true;
  }
}
